const radius = {
  "radius-default": {
    displayText: "Uses a radius of 8 pixels.",
    value: "8px"
  },
  "radius-sm": {
    displayText: "Uses a radius of 4 pixels.",
    value: "4px"
  },
  "radius-full": {
    displayText: "Uses a full radius for full rounded corners.",
    value: "999px"
  }
};
export {
  radius
};
//# sourceMappingURL=radius.es.js.map
